<template>
  <component
    :is="shouldShowLink ? 'iLink' : 'iText'"
    :href="shouldShowLink ? builderNoNavHref : undefined"
    v-bind="fullTextOptionsAttributes"
    :style-overrides="myStyleOverrides"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :target="shouldShowLink ? target : undefined"
    :rel="shouldShowLink ? rel : undefined"
    :width="fullTextOptionsAttributes.width"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
    :background-position="shouldShowLink ? getOptionValue(BackgroundPosition) : undefined"
    :background-size="shouldShowLink ? getOptionValue(BackgroundSize) : undefined"
    :background-repeat="shouldShowLink ? getOptionValue(BackgroundRepeat) : undefined"
    :hover-background-position="shouldShowLink ? getOptionValue(BackgroundPosition, BaseOption.$states.HOVER) : undefined"
    :hover-background-size="shouldShowLink ? getOptionValue(BackgroundSize, BaseOption.$states.HOVER) : undefined"
    :hover-background-repeat="shouldShowLink ? getOptionValue(BackgroundRepeat, BaseOption.$states.HOVER) : undefined"
  >
    <slot>
      <PrefixSuffixWrapper
        v-if="hasLabel && (getOptionValue(Prefix) || getOptionValue(Suffix))"
        :prefix="getOptionValue(Prefix)"
        :suffix="getOptionValue(Suffix)"
        :style-bindings="textOnlyAttributes"
      >
        {{ label }}
      </PrefixSuffixWrapper>
      <template v-else-if="hasLabel">
        {{ label }}
      </template>
    </slot>
  </component>
</template>

<script>
// Lightweight canvas render for unselected `UrlElement` instances.
// Mirrors `UrlElement.vue`'s iLink output but skips iRichText, the link-
// picker modal, and the inline-edit handlers — the label projects through
// `renderedText` from the `HrefAction.label` option (same source-of-truth
// rule as the Builder variant).
//
// Mounted by `DynamicComponentBuilderElement` whenever the element is not
// selected for editing OR is rendered on a non-default breakpoint frame.
import {
  UrlElementRenderMixin,
} from "%/dynamic-component-editor/standard-elements/url-element/url-element-render-mixin";
import HrefAction from "%/dynamic-component-editor/options/href-action";
import BackgroundImage from "%/dynamic-component-editor/options/background-image";
import BackgroundGradient from "%/dynamic-component-editor/options/background-gradient";
import BackgroundRepeat from "%/dynamic-component-editor/options/background-repeat";
import BackgroundPosition from "%/dynamic-component-editor/options/background-position";
import BackgroundSize from "%/dynamic-component-editor/options/background-size";
import BaseOption from "%/dynamic-component-editor/classes/base-option";
import Prefix from "%/dynamic-component-editor/options/prefix";
import Suffix from "%/dynamic-component-editor/options/suffix";
import PrefixSuffixWrapper from "%/dynamic-component-editor/components/PrefixSuffixWrapper.vue";

export default {
  name: "UrlElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  components: { PrefixSuffixWrapper },
  mixins: [UrlElementRenderMixin],
  data() {
    return {
      Prefix,
      Suffix,
      BackgroundImage,
      BackgroundGradient,
      BackgroundRepeat,
      BackgroundPosition,
      BackgroundSize,
      BaseOption,
      HrefAction,
    };
  },
};
</script>
